import { http } from '../../utils/http'
export const UABASE = window.$envUtils('VUE_APP_AFF_SERVICE')

// 测试工具日志集合查询
export const getTestToolLogList = (params) => {
  return http.get(`${UABASE}/ttl/testToolLog`, { params })
}
